<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('profile.material.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('global.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.htmlcode"
            :error-messages="htmlcodeErrors"
            :label="$t('profile.material.color')"
            required
            @input="$v.item.htmlcode.$touch()"
            @blur="$v.item.htmlcode.$touch()"
          />
        </v-col>
        <v-col cols="12"></v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'MaterialColorForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
  },
  data() {
    return {
        name: null,
        namefr: null,
        htmlcode: null,
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) return errors;
      has(this.violations, 'name') && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    namefrErrors() {
      const errors = [];
      if (!this.$v.item.namefr.$dirty) return errors;
      has(this.violations, 'namefr') && errors.push(this.violations.namefr);
      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    htmlcodeErrors() {
      const errors = [];

      if (!this.$v.item.htmlcode.$dirty) return errors;

      has(this.violations, 'htmlcode') && errors.push(this.violations.htmlcode);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      name: {
        required,
      },
      namefr: {
        required,
      },
      htmlcode: {
      },
    }
  }
};
</script>
